"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyTermSelect = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var terms_1 = require("./terms");
function PolicyTermSelect(props) {
    var onChange = props.onChange, value = props.value, disabled = props.disabled;
    return (react_1.default.createElement(core_ui_1.SelectInput
    // since SelectInput only works with strings, we need to map month values to use them as strings
    , { 
        // since SelectInput only works with strings, we need to map month values to use them as strings
        options: terms_1.POLICY_TERMS.map(function (policyTerm) { return (__assign(__assign({}, policyTerm), { value: policyTerm.value.toString() })); }).concat({
            label: 'Other',
            value: 'other',
        }), testId: "policy-term-select", onChange: function (nextValue) {
            if (nextValue === 'other') {
                return onChange(null);
            }
            // convert it back to number
            onChange(parseInt(nextValue, 10));
        }, 
        // null means "Other", undefined means that the select wasn't set yet
        value: value === null ? 'other' : value === null || value === void 0 ? void 0 : value.toString(), disabled: disabled, showSelectAnOption: true, placeholder: "Select policy term" }));
}
exports.PolicyTermSelect = PolicyTermSelect;
